import axios from 'axios';
import { TOKEN_KEY } from '../utils/constants';
import {
  clearStoredAuth,
  emitSessionEndedEvent,
  stashSessionEndedMessage,
} from './authSession';

const API_URL = `${process.env.REACT_APP_API_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const token = localStorage.getItem(TOKEN_KEY);
      if (token) {
        const code = error.response?.data?.code;
        const message =
          error.response?.data?.message || 'Your session is no longer active. Please login again.';
        clearStoredAuth();
        if (code === 'SESSION_REPLACED' || code === 'SESSION_INVALID') {
          emitSessionEndedEvent({ code, message });
          stashSessionEndedMessage(message);
        }
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
